import * as React from 'react';

import type { ProgramCurriculumProductsQuery_ProgramCurriculumProductsV1Resource_multiGet_elements } from 'bundles/enterprise-learning-path-description-page/queries/__generated__/ProgramCurriculumProductsQuery';

type CurriculumProduct =
  NonNullable<ProgramCurriculumProductsQuery_ProgramCurriculumProductsV1Resource_multiGet_elements>;

type EnterpriseLearningPathCurriculumContextType = {
  curriculumProducts: CurriculumProduct[];
  loading: boolean;
  error?: Error;
  refetch: () => Promise<void>;
};

const EnterpriseLearningPathCurriculumContext = React.createContext<EnterpriseLearningPathCurriculumContextType>({
  curriculumProducts: [],
  loading: false,
  error: undefined,
  refetch: () => Promise.resolve(),
});

export const useEnterpriseLearningPathCurriculum = () => {
  const context = React.useContext(EnterpriseLearningPathCurriculumContext);
  if (!context) {
    throw new Error(
      'useEnterpriseLearningPathCurriculum must be used within an EnterpriseLearningPathCurriculumProvider'
    );
  }
  return context;
};

export default EnterpriseLearningPathCurriculumContext;
